// Reference ::BookingPortal::InvoicePrefs::Kind
export const INVOICE_TO = {
  MYSELF: 0,
  CLIENT: 1,
  OTHER: 2,
};

export const PAYMENT_METHOD = {
  CREDIT_CARD: 'credit_card_payment',
};

export const NO_CLIENT_ID = -1;
